import { Box, Container, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import ScrollToTopButton from "./Utilities/ScrollToTopButton";
import { Helmet } from "react-helmet-async";


const MetaTrader5forAndroid = () => {

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    fontWeight: "bold",
    backgroundColor: "#f5f5f5",
    color: "#333",
  }));

  const StyledRow = styled(TableRow)(({ theme, index }) => ({
    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9f9f9",
  }));

  const comparisonData = [
    { feature: "Order Execution Types", mt5: "4 Types", others: "4 Types" },
    { feature: "Pending Order Options", mt5: "6 Types", others: "4 Types" },
    { feature: "Tradable Instruments", mt5: "Unlimited", others: "Up to 1024" },
    {
      feature: "Built-in Indicators",
      mt5: "38+",
      others: "30 ",
    },
    {
      feature: "Chart Timeframes",
      mt5: "21 ",
      others: "9 ",
    },
    {
      feature: "Drawing & Analysis Tools",
      mt5: "44 Objects",
      others: "31 Objects",
    },
    {
      feature: "Copy Trading",
      mt5: "Advanced Native Charting",
      others: "Native Charting",
    },
    { feature: "Copy Trading & Signals", mt5: "Enabled", others: "Enabled" },
    {
      feature: "Reporting Format",
      mt5: "Advanced Interactive Charts & Tables",
      others: "Basic Tables Only",
    },
    { feature: "Mobile Trading Apps", mt5: "Available", others: "Available" },
  ];

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://www.hcfinvest.com/metaTrade5Android" />
      </Helmet>

          <Container sx={{ backgroundColor: "#fff" }} maxWidth={false} disableGutters>
      <ScrollToTopButton />
      <Box
        sx={{
          position: "relative",
          height: "475px",
          display: "flex",
          flexDirection: "column", // 👈 Stack text vertically
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          backgroundImage: `url('Images/MetaTrader5Android/hedgestandardaccimage.jpg')`, // 👈 replace with your image path
          backgroundSize: "cover",
          backgroundPosition: "center",
          marginBottom: "30px",
        }}
      >
        <h1
          // variant="h3"
          // component="h1"
          sx={{
            zIndex: 2,
            fontWeight: 600,
            textAlign: "center",
            px: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          MetaTrader 5 For Mobile(Android/IOS)
        </h1>
        <h3
          // variant="h5"
          // component="h1"
          sx={{
            zIndex: 2,
            fontWeight: 600,
            textAlign: "center",
            px: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Trade the world with HC Finvest
        </h3>
      </Box>

      <Typography
        sx={{
          fontSize: "17px",
          lineHeight: "32px",
          color: "var(--bs-secondary-color) !important",
          paddingRight: "100px",
          paddingLeft: "100px",
          marginTop: "70px",
          marginBottom: "50px",
          textAlign: "left",
          fontWeight: "600",
        }}
      >
        "Transform your trading experience with HC Finvest MetaTrader 5 .
        Designed for both novice and experienced traders, our app combines
        advanced features with a user-friendly interface, empowering you to
        trade smarter and faster."
      </Typography>

 <section className="what-is">


      <div className="container mt-4">
        <div className="row align-items-center">
          {/* Left Image */}
          <div className="col-12 col-lg-4 mb-4 mb-lg-0">
            <img
              src="/Images/MetaTrader5Android/metaTrader5Android.png"
              alt="MT5 Mobile View"
              className="img-fluid"
            />
          </div>

          {/* Right Text */}
          <div className="col-12 col-lg-8 col-xl-7 offset-xl-1">
            <div
              className="lead text-dark"
              style={{ color: "#101828", fontFamily: "Poppins" }}
            >
              <p
                className="text-muted"
                style={{ lineHeight: "32px", fontSize: "16px" }}
              >
                <Typography sx={{mb:1}}>               
                  <span
                  className="text-bold"
                  style={{ color: "#ff8c00" , fontWeight:'600' }}
                >
                  Real-Time Market Access :-
                </span>{" "}
                Stay updated with live market data and never miss a trading
                opportunity.
                </Typography>

                <Typography sx={{mb:1}}>
                  <span
                  className="text-bold"
                  style={{ color: "#ff8c00" , fontWeight:'600'}}
                >
                  Advanced Charting Tools :-
                </span>{" "}
                Analyze market trends with comprehensive charting tools and
                technical indicators.
                </Typography>

                <Typography sx={{mb:1}}>
                  <span
                  className="text-bold"
                  style={{ color: "#ff8c00",  fontWeight:'600' }}
                >
                  Seamless Execution :-
                </span>{" "}
                Execute trades quickly and efficiently with our user-friendly
                mobile interface.
                </Typography>

                <Typography sx={{mb:1}}>
                  <span
                  className="text-bold"
                  style={{ color: "#ff8c00",  fontWeight:'600' }}
                >
                  Custom Alerts :-
                </span>{" "}
                Set personalized alerts for price movements and trading signals
                to stay ahead of the market.
                </Typography>

                <Typography sx={{mb:1}}>
                  <span
                  className="text-bold"
                  style={{ color: "#ff8c00" , fontWeight:'600'}}
                >
                  Secure Transactions :-
                </span>{" "}
                Trade with confidence knowing that your data and transactions
                are protected with industry-leading security measures.
                </Typography>
              </p>

              {/* Download Buttons */}
              <div className="container mt-4">
                <div className="row g-2">
                  <div className="col-12 col-md-4">
                    <a
                      href="https://apps.apple.com/in/app/metatrader-5/id413251709"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      <button
                        className="btn w-100 text-white"
                        style={{ backgroundColor: "#ff8c00" }}
                      >
                        <i className="bi bi-download me-2"></i> iOS
                      </button>
                    </a>
                  </div>
                  <div className="col-12 col-md-4">
                    <a
                      href="https://play.google.com/store/apps/details?id=net.metaquotes.metatrader5"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      <button
                        className="btn w-100 text-white"
                        style={{ backgroundColor: "#ff8c00" }}
                      >
                        <i className="bi bi-download me-2"></i> Play Store
                      </button>
                    </a>
                  </div>
                  <div className="col-12 col-md-4">
                    <a
                      href="https://galaxystore.samsung.com/detail/net.metaquotes.metatrader5"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      <button
                        className="btn w-100 text-white"
                        style={{ backgroundColor: "#ff8c00" }}
                      >
                        <i className="bi bi-download me-2"></i> Samsung Store
                      </button>
                    </a>
                  </div>
                </div>
              </div>
              {/* End Download Buttons */}
            </div>
          </div>
        </div>
      </div>
    </section>

      <Grid>
<Typography
  variant="h3"
  fontWeight="bold"
  sx={{
    mt: { xs: 4, md: 8 },                   // margin-top responsive
    fontSize: {
      xs: "24px",  // mobile
      sm: "28px",  // small tablets
      md: "35px",  // laptops
      lg: "42px",  // large screens
    },
    textAlign: "center",
  }}
>
  Experience the Future of Trading –{" "}
  <span style={{ color: "#ff8c00" }}>MetaTrader 5</span> Reinvented.
</Typography>
        <Typography sx={{ marginTop: 3 }}>
          Give Your Trades Speed, Intelligence, and Control
        </Typography>

        <TableContainer
          component={Paper}
          elevation={4}
          sx={{
            maxWidth: 1200,
            margin: "auto",

            mt: 4,
            boxShadow: "0 0 20px #00000014;",
            // display:'flex',
            // justifyContent:'center',
            // alignItems:'center'
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell
                  sx={{ color: "white", backgroundColor: "#ff8c00" }}
                >
                  Feature
                </StyledTableCell>
                <StyledTableCell
                  sx={{ color: "white", backgroundColor: "#ff8c00" }}
                >
                  MetaTrader 5
                </StyledTableCell>
                <StyledTableCell
                  sx={{ color: "white", backgroundColor: "#ff8c00" }}
                >
                  Other Platforms
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {comparisonData.map((row, index) => (
                <StyledRow key={index} index={index}>
                  <TableCell>{row.feature}</TableCell>
                  <TableCell>{row.mt5}</TableCell>
                  <TableCell>{row.others}</TableCell>
                </StyledRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      <Grid
        sx={{
          backgroundColor: "#f8f9fa",
          marginTop: "50px",
          paddingBottom: "50px",
        }}
      >
        <Typography
          sx={{
            fontSize: "calc(1.325rem + .9vw)",
            fontWeight: "700",
            color: "#101828",
            marginBottom: "1.5rem",
            paddingTop: "1rem",
          }}
        >
          Download the <span style={{ color: "#ff8c00" }}>MetaTrader 5</span>
        </Typography>
<div className="w-100 py-5 bg-light">
      <div className="container text-black text-center">

        <div className="row justify-content-center g-4">
          
          {/* iOS */}
          <div className="col-12 col-sm-6 col-md-4">
            <div className="bg-white rounded-4 p-4 shadow-sm h-100 text-center">
              <img
                src="/Images/MetaTrader5Android/adobe-express-qr-code 1.png"
                alt="iOS QR Code"
                className="img-fluid rounded qr-img"
              />
              <div className="mt-3">
                <img
                  src="/Images/MetaTrader5Android/appstore.png"
                  alt="App Store"
                  height="40"
                  width="40"
                />
              </div>
            </div>
          </div>

          {/* Android - Samsung Store */}
          <div className="col-12 col-sm-6 col-md-4">
            <div className="bg-white rounded-4 p-4 shadow-sm h-100 text-center">
              <img
                src="/Images/MetaTrader5Android/adobe-express-qr-code (3).png"
                alt="Samsung Store QR"
                className="img-fluid rounded qr-img"
              />
              <div className="mt-3">
                <img
                  src="/Images/MetaTrader5Android/samsung-galaxy-store-logo-png_seeklogo-43825.png"
                  alt="Samsung Store"
                  height="50"
                  width="55"
                />
              </div>
            </div>
          </div>

          {/* Android APK - Play Store */}
          <div className="col-12 col-sm-6 col-md-4">
            <div className="bg-white rounded-4 p-4 shadow-sm h-100 text-center">
              <img
                src="/Images/MetaTrader5Android/adobe-express-qr-code (2).png"
                alt="Play Store QR"
                className="img-fluid rounded qr-img"
              />
              <div className="mt-3">
                <img
                  src="/Images/MetaTrader5Android/playstore.png"
                  alt="Play Store"
                  height="45"
                  width="45"
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
      </Grid>

      <Grid
        container
        sx={{
          position: "relative",
          height: "300px",
          backgroundImage: 'url("/Images/MainContentImages/New CTA (1).webp")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          overflow: "hidden",
        }}
      >
        {/* Optional dark overlay for better text contrast */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            // backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1,
          }}
        />

        {/* Text Content */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            color: "black",
            zIndex: 2,
          }}
        >
          <Typography variant="h4" fontWeight="bold" sx={{ mb: 1 }}>
            Start Trading today with{" "}
            <span style={{ color: "#ff8c00" }}>HC Finvest</span>
          </Typography>
          <Typography variant="body1">
            Ready to assist you in every step of your trading experience, 24/5
            multilingual customer
          </Typography>
          <Typography variant="body1">
            support with Dedicated Account Managers.
          </Typography>

          <Grid
            container
            size={12}
            spacing={5}
            sx={{
              border: "0px solid green",
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid item size={2} sx={{ border: "0px solid red" }}>
              <a
                _ngcontent-ng-c673006511=""
                // href="/contact-us"
                class="text-white text-decoration-none"
              >
                <svg
                  _ngcontent-ng-c673006511=""
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  height="35px"
                  style={{ fill: "#ff8c00" }}
                >
                  <path
                    _ngcontent-ng-c673006511=""
                    d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
                  ></path>
                </svg>
              </a>
            </Grid>
            <Grid item size={2} sx={{ border: "0px solid red" }}>
              <a
                _ngcontent-ng-c673006511=""
                // href="https://wa.me/447441395542"
                target="_blank"
                class="text-white text-decoration-none"
              >
                <svg
                  _ngcontent-ng-c673006511=""
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  height="35px"
                  style={{ fill: "#ff8c00" }}
                >
                  <path
                    _ngcontent-ng-c673006511=""
                    d="M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"
                  ></path>
                </svg>
              </a>
            </Grid>
            <Grid item size={2} sx={{ border: "0px solid red" }}>
              <a
                _ngcontent-ng-c673006511=""
                // href="mailto:support@hcfinvest.com"
                class="text-white text-decoration-none"
              >
                <svg
                  _ngcontent-ng-c673006511=""
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  height="35px"
                  style={{ fill: "#ff8c00" }}
                >
                  <path
                    _ngcontent-ng-c673006511=""
                    d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
                  ></path>
                </svg>
              </a>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Container>
    </>
  );
};
export default MetaTrader5forAndroid;
